<template>
    <v-container class="py-0 shopControlPanel" fluid>
        <div class="d-flex justify-space-between">
            <div class="d-flex align-center">
                <div class="mr-4 d-flex">
                    <TranslatableStringComponent :tstring="{string: 'results'}" />: <span style="width: 40px; margin-left: 2px;"><b>{{ totalItemsServer }}</b></span><TranslatableStringComponent :tstring="{string: 'items'}" />
                </div>
                <div class="mr-1"><TranslatableStringComponent :tstring="{string: 'itemsPerPage'}" />:</div>
                <v-select
                    hide-details
                    dense
                    v-model="itemsPerPage"
                    style="width: 60px"
                    :items="rowsPerPageItems"
                    class="ma-0"
                ></v-select>
            </div>
            <v-pagination
                v-model="page"
                :length="pageCount"
                :total-visible="7"
            ></v-pagination>
        </div>
    </v-container>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
const { mapFields } = createHelpers({
    getterType: 'shop/getField',
    mutationType: 'shop/updateField',
})
export default {
    name: 'ShopControlPanel',
    components: { TranslatableStringComponent, },
    data() {
        return {}
    },
    props: {},
    mounted() {},
    watch: {},
    computed: {
        ...mapFields([
            'totalItemsServer',
            'page',
            'itemsPerPage',
            'pageCount',
            'rowsPerPageItems',
        ]),
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.rem-border {
    border: 0;
}
nav {
    width: 370px !important;
}
</style>
